var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-site m-auto",class:[
    _vm.topPadding ? 'pt-6' : '',
    _vm.extraTopPadding ? 'xl:pt-12' : '',
    _vm.bottomPadding ? (_vm.smallBottomPadding ? 'pb-6' : 'pb-14') : '',
    _vm.maxWidth,
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }